export default "__VITE_ASSET__C35xCJ1p__"